import React, { useLayoutEffect, useRef, useState } from 'react'
import WaveSurfer from 'wavesurfer.js'

import { SxProps } from '@mui/system'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded'
import PauseRoundedIcon from '@mui/icons-material/PauseRounded'
import StopRoundedIcon from '@mui/icons-material/StopRounded'

type AudioViewerProps = {
  src: string
  sx?: SxProps
}

export function AudioViewer(props: AudioViewerProps) {
  const { src, sx = [] } = props
  const wavesurferRef = useRef<WaveSurfer>()
  const wsContainerRef = useRef<HTMLDivElement>()

  const [playing, setPlaying] = useState<boolean>(false)

  useLayoutEffect(() => {
    if (!wsContainerRef.current) return

    if (wavesurferRef.current) wavesurferRef.current.destroy()

    const wavesurfer = WaveSurfer.create({
      backend: 'WebAudio',
      container: wsContainerRef.current,
      waveColor: '#EFEFEF',
      progressColor: '#2D5BFF',
      height: 80,
      cursorWidth: 1,
      cursorColor: 'transparent',
      normalize: true
    })

    wavesurfer.load(src)
    wavesurfer.on('error', (error: any) => {
      console.log(error)
    })
    wavesurfer.on('finish', () => {
      setPlaying(false)
    })
    wavesurferRef.current = wavesurfer
  }, [src])

  const handlePlay = () => {
    setPlaying((prevPlaying) => !prevPlaying)
    wavesurferRef.current?.playPause()
  }

  const handleStop = () => {
    wavesurferRef.current?.stop()
  }

  return (
    <Paper sx={[{ width: '500px', p: '5px' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={handlePlay}>{playing ? <PauseRoundedIcon /> : <PlayArrowRoundedIcon />}</IconButton>
          <IconButton onClick={handleStop}>
            <StopRoundedIcon />
          </IconButton>
        </Stack>
        <Box ref={wsContainerRef} sx={{ flex: 1 }} />
      </Stack>
    </Paper>
  )
}

export default AudioViewer
